/* eslint-disable */
// react imports
import { useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import { Breadcrumbs as MuiBreadcrumbs } from "@mui/material";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Context imports
import { useMaterialUIController, setDisplayName } from "context";

// Firebase imports
import { doc, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { db } from "../../Firebase";

function Breadcrumbs({ icon, title, route, light }) {
  const routes = route.slice(0, -1);

  const [controller, dispatch] = useMaterialUIController();
  const { displayName } = controller;

  const auth = getAuth();
  const user = auth.currentUser;

  useEffect(() => {
    const localStorageDisplayName = window.localStorage.getItem("displayName");
    if (localStorageDisplayName === null || localStorageDisplayName === undefined) {
      const setDisplayNameFromFirebase = async () => {
        const userDoc = doc(db, "USERS", user.uid);
        const docSnap = await getDoc(userDoc);
        const userEmail = docSnap.data().firstName;
        window.localStorage.setItem("displayName", userEmail);
        setDisplayName(dispatch, userEmail);
      };
      setDisplayNameFromFirebase();
    }
    setDisplayName(dispatch, localStorageDisplayName);
  }, []);

  return (
    <MDBox mr={{ xs: 0, xl: 8 }}>
      <MuiBreadcrumbs
        sx={{
          "& .MuiBreadcrumbs-separator": {
            color: ({ palette: { white, grey } }) => (light ? white.main : grey[600]),
          },
        }}
      >
        <Link to="/">
          <MDTypography
            component="span"
            variant="body2"
            color={light ? "white" : "dark"}
            opacity={light ? 0.8 : 0.5}
            sx={{ lineHeight: 0 }}
          >
            <Icon>{icon}</Icon>
          </MDTypography>
        </Link>
        {routes.map((el) => (
          <Link to={`/${el}`} key={el}>
            <MDTypography
              component="span"
              variant="button"
              fontWeight="regular"
              textTransform="capitalize"
              color={light ? "white" : "dark"}
              opacity={light ? 0.8 : 0.5}
              sx={{ lineHeight: 0 }}
            >
              {el}
            </MDTypography>
          </Link>
        ))}
        <MDTypography
          variant="button"
          fontWeight="regular"
          color={light ? "white" : "dark"}
          sx={{ lineHeight: 0 }}
        >
          {title.replaceAll("_", " ").replaceAll("-", " ").replace("STUDY", "Study")}
        </MDTypography>
      </MuiBreadcrumbs>
      <MDTypography
        fontWeight="bold"
        textTransform="capitalize"
        variant="h6"
        color={light ? "white" : "dark"}
        noWrap
      >
        Hello, {displayName}!
      </MDTypography>
    </MDBox>
  );
}

// Setting default values for the props of Breadcrumbs
Breadcrumbs.defaultProps = {
  light: false,
};

// Typechecking props for the Breadcrumbs
Breadcrumbs.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  route: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  light: PropTypes.bool,
};

export default Breadcrumbs;
